import React from "react";
export default function Loading() {
  return (
    <svg
      viewBox="25 25 50 50"
      className="w-[3.25em] animate-[rotate4_2s_linear_infinite]"
      style={{ transformOrigin: "center" }}
    >
      <defs>
        <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1d4289" />
          <stop offset="100%" stopColor="#00b74f" />
        </linearGradient>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="url(#gradientStroke)"
        strokeWidth="2"
        strokeDasharray="1, 200"
        strokeDashoffset="0"
        strokeLinecap="round"
        className="animate-[dash4_1.5s_ease-in-out_infinite]"
      />

      <style jsx global>{`
        @keyframes rotate4 {
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes dash4 {
          0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 90, 200;
            stroke-dashoffset: -35px;
          }
          100% {
            stroke-dashoffset: -125px;
          }
        }
      `}</style>
    </svg>
  );
}
